<template>
  <div id="nav" class="w3-content w3-padding w3-bar">
    <!-- <span><img alt="logo" style="filter: brightness(10%)" width=70 src="@/assets/img/logo.png"></span> -->

    <router-link :to="{ name: 'home' }" class="">
      <img alt="logo" class="sepia" style="filter: brightness(100%);margin-top:-0.8rem" width=80 src="@/assets/img/b.png">
    </router-link>


      <span class="w3-right" style="margin-top:10px">
        <!-- <router-link :to="{ name: 'about' }" class="w3-bar-item">About</router-link> -->
        <!-- <router-link :to="{ name: 'features' }" class="w3-bar-item">Features</router-link>
        <router-link :to="{ name: 'blog' }" class="w3-bar-item">Blog</router-link> -->
        <span v-if="!isLoggedIn">
          <router-link :to="{ name: 'login' }" class="w3-bar-item">LOG IN</router-link>
          <router-link :to="{ name: 'signup' }" class="w3-bar-item item-nav w3-card">SIGN UP</router-link>
        </span>
        <span v-else>
          <a class="w3-bar-item" @click="logoutUser">Logout</a>
        </span>
        <!-- <span>
          <router-link :to="{ name: 'profile' }" class="w3-bar-item w3-button">
            Hello
            <span v-show="isLoggedIn">{{ user.username }} </span>
            <span v-if="!isLoggedIn">Guest</span>
          </router-link>
        </span>
      -->
      </span>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import router from '@/router'

export default {
  name: 'Navbar',

  methods: {
    ...mapActions('auth', ['logout']),
    logoutUser: function () {
      this.logout()
    },
  },

  computed: mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
}

</script>

<style>
.item-nav{
  background: #4A61DD;
  margin: 0 3px 0 3px;
  border-radius: 5px;
}

#nav {
  /* padding: 15px; */
  color: white;
  /* background-color: #827ffe; */
}

#nav a {
  /* padding: 15px; */
  font-weight: bold;
  /* color: #2c3e50; */
  text-decoration: none;
}

/* #nav a:hover {
  border-bottom: 1px solid #ccc;
} */

#nav a.router-link-exact-active {
  /* text-decoration: underline; */
  /* color: #827ffe; */
}

/*Filter styles*/
.saturate { filter: saturate(3); }
.grayscale { filter: grayscale(100%); }
.contrast { filter: contrast(160%); }
.brightness { filter: brightness(0.25); }
.blur { filter: blur(3px); }
.invert { filter: invert(100%); }
.sepia { filter: sepia(100%); }
.huerotate { filter: hue-rotate(180deg); }
.rss.opacity { filter: opacity(50%); }
</style>
